<template>
  <div class="comunication-management width-responsiveness">
    <div class="comunication-management__container">
      <subheader title="Administração de Notificações" />
      <div>
        <h2 class="comunication-management__title--primary title-main">
          Incluir Avisos
        </h2>
        <comunication-form />
      </div>
    </div>

    <div class="comunication-management__container">
      <h2 class="comunication-management__title--secondary title-main">
        Gerenciar Avisos
      </h2>
    </div>

    <comunication-list />
  </div>
</template>

<script>
import ComunicationForm from './ComunicationForm'
import ComunicationList from './ComunicationList'
import SubHeader from '@/components/common/SubHeader'

export default {
  name: 'ComunicationManagement',
  components: {
    subheader: SubHeader,
    'comunication-list': ComunicationList,
    'comunication-form': ComunicationForm
  }
}
</script>

<style lang="scss">
@import "../../../../static/stylesheets/mixins";

.comunication-management {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);
  margin-top: 150px;

  &__container {
    width: 100%;
  }

  &__title {
    &--primary {
      margin: 10px 0 30px;
    }

    &--secondary {
      padding: 40px 0;
    }
  }

}

.edit-alert-modal {
  width: 100% !important;
  min-width: 500px !important;

  .md-dialog {
    min-width: 95% !important;
    width: 100% !important;
    height: 100% important;
  }
}
</style>
